import React, { useEffect } from 'react';
import EDEKAsmartLogo from '@theme/assets/img/EDEKAsmart_logo_neg.svg';
import { deviceRegex, appRoute } from '@utils/globalConstant';
import AppPageContentWrapper from '@part/AppPageContentWrapper';
import Ta11yText from '@core/Ta11yText';
import { useA11y } from '@context/Utils';

export function RateAppRedirect() {
  const { tA11yTranslate } = useA11y();
  const androidStoreUrl = tA11yTranslate('ek_store_review_android_url');
  const iosStoreUrl = tA11yTranslate('ek_store_review_ios_url');

  useEffect(() => {
    const userAgent = navigator.userAgent;
    if (androidStoreUrl?.url && iosStoreUrl?.url) {
      if (deviceRegex.ISANDRIOD.test(userAgent)) {
        window.location.href = androidStoreUrl?.url;
      } else if (deviceRegex.ISIOS.test(userAgent) && !window.MSStream) {
        window.location.href = iosStoreUrl?.url;
      } else {
        window.location.href = appRoute.HOME_PAGE;
      }
    }
  }, [androidStoreUrl, iosStoreUrl]);

  return (
    <>
      <AppPageContentWrapper>
        <div className="sticky-top">
          <div className="logo">
            <a href={appRoute.HOME_PAGE}>
              <img src={EDEKAsmartLogo} alt="Edeka Smart" />
            </a>
          </div>
        </div>
        <div
          className="d-flex flex-column align-items-center justify-content-center text-center"
          style={{ height: 'calc(100vh - 232px)' }}>
          <Ta11yText
            tag="h3"
            textContent={tA11yTranslate('ek_store_review_hdl')}
            className={'ek-h1 m-0 px-3 text-uppercase'}
          />
          <Ta11yText
            tag="p"
            textContent={tA11yTranslate('ek_store_review_txt')}
            className={'ek-copy-16-regular pt-5'}
          />
        </div>
      </AppPageContentWrapper>
    </>
  );
}

export default RateAppRedirect;
